export const DISCLAIMER = 'Se cuenta con autorización por escrito para la publicación y difusión de esta cédula de búsqueda';

const imageError = () => new Error('No se pudo cargar una imagen de la cédula.');

const waitForImage = (image) => {
    if (typeof image.decode === 'function') return image.decode();
    if (image.complete) return image.naturalWidth > 0 ? Promise.resolve() : Promise.reject(imageError());

    return new Promise((resolve, reject) => {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', () => reject(imageError()), { once: true });
    });
};

export const waitForPngCapture = async (node) => {
    if (document.fonts?.ready) await document.fonts.ready;
    const images = node ? Array.from(node.querySelectorAll('img')) : [];
    await Promise.all(images.map(waitForImage));
};

const SVG_SRC = /\.svg([?#]|$)|^data:image\/svg\+xml/i;

// En iOS (Safari, Chrome y Firefox usan el WebKit de Apple) drawImage pinta un SVG a su tamaño
// intrínseco e ignora el rectángulo destino; html2canvas lo recorta a la caja y los iconos FB/X y el
// logo de Jalisco salen vacíos (o la COBUPEJ gigante). Para html2canvas `onclone`: cada <img> SVG
// del clon pasa a PNG ya del tamaño final, dibujado sin destino y escalado con la matriz.
// Se dibuja una Image nueva, fuera del DOM: de un <img> renderizado WebKit toma su tamaño CSS.
export const rasterizeSvgImages = (scale) => (_doc, root) => Promise.all(
    Array.from(root.querySelectorAll('img')).map(async (img) => {
        const src = img.currentSrc || img.src;
        const { width, height } = img.getBoundingClientRect();
        if (!SVG_SRC.test(src) || !width || !height) return;

        const svg = new Image();
        svg.src = src;
        await waitForImage(svg);
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(width * scale);
        canvas.height = Math.round(height * scale);
        const ctx = canvas.getContext('2d');
        ctx.scale(canvas.width / svg.naturalWidth, canvas.height / svg.naturalHeight);
        ctx.drawImage(svg, 0, 0);
        img.src = canvas.toDataURL('image/png');
        await waitForImage(img);
    })
);
